var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3336 16.8412C28.3336 17.4253 28.1271 17.9406 27.7141 18.3873L26.4586 19.6758C26.0345 20.111 25.5266 20.3286 24.9351 20.3286C24.3325 20.3286 23.8302 20.111 23.4284 19.6758L18.5066 14.6422V26.7365C18.5066 27.332 18.2973 27.8159 17.8788 28.1881C17.4602 28.5603 16.9552 28.7464 16.3637 28.7464H14.2208C13.6293 28.7464 13.1243 28.5603 12.7058 28.1881C12.2872 27.8159 12.078 27.332 12.078 26.7365V14.6422L7.15611 19.6758C6.75433 20.111 6.25209 20.3286 5.64941 20.3286C5.04674 20.3286 4.5445 20.111 4.14272 19.6758L2.88714 18.3873C2.46303 17.9521 2.25098 17.4367 2.25098 16.8412C2.25098 16.2342 2.46303 15.7131 2.88714 15.2779L13.7856 4.09413C14.1762 3.67037 14.6784 3.4585 15.2923 3.4585C15.895 3.4585 16.4028 3.67037 16.8157 4.09413L27.7141 15.2779C28.1271 15.7245 28.3336 16.2456 28.3336 16.8412Z",
    fill: "#810CA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopArrow);
export default __webpack_public_path__ + "static/media/TopArrow.c0d744fa289d2190db54599d96381d73.svg";
export { ForwardRef as ReactComponent };